export default __webpack_public_path__ + "static/media/kanbanDefault.e3d16a63.svg";